import './styles.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk'
//import createLogger from 'redux-logger'
import { Router, Route, browserHistory } from 'react-router';
import { flickrCombinedReducers } from './flickr-redux/reducers';
import AppContainer from './AppContainer';
import SearchContainer from './search/SearchContainer';
import GalleryContainer from './gallery/GalleryContainer';
import FavoritesContainer from './favorites/FavoritesContainer';

//const loggerMiddleware = createLogger();

let store = createStore(
	flickrCombinedReducers,
  {},
	applyMiddleware(thunkMiddleware/*, loggerMiddleware*/)
);

ReactDOM.render(
  <Provider store={store}>
  	<Router history={browserHistory}>
  		<Route path="/" component={AppContainer}>
  			<Route path="/search" component={SearchContainer} />
  			<Route path="/gallery" component={GalleryContainer} />
        <Route path="/favorites" component={FavoritesContainer} />
        <Route path="*" component={SearchContainer} />
  		</Route>
  	</Router>
  </Provider>,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/